<div class="alert" [ngClass]="'alert--' + type">
  <tp-icon class="alert__icon" [name]="'icons/' + iconName"></tp-icon>
  <ng-content></ng-content>
</div>
